import React from "react";
import { DrawSheetProps } from "./types";
import { useLazyLoad } from "../../../helpers/hooks";
const DrawSheets = React.lazy(() => import("./"));

export default (props: DrawSheetProps) =>
  useLazyLoad(<DrawSheets {...props} />);
